export default __webpack_public_path__ + "static/media/user-oldie.8afff3bd.svg";